import {useQuery} from 'react-query'
import api from '../api'

export const useGetProductQuery = (productId: string) => {
  return useQuery(['getProduct', productId], () => api.getProduct(productId), {
    keepPreviousData: true,
  })
}
